// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__2xfZk","headshotBorder":"About_headshotBorder__3tfnj","headshot":"About_headshot__yZdAg","content":"About_content__1QyNt"};